<template>
  <div
    v-click-outside="hide"
    class="filter__order"
    :class="{
      'filter__order--active': sortView.visible,
      'filter__order--20321B': newStyle20321B,
    }"
    @click="sortView.toggleMenu()"
  >
    <div class="filter__active">
      <span class="filter__icon iconfont" :class="sortView.activeOptIcon"></span
      >{{ sortView.displayedSortOptionName }}
    </div>
    <span class="filter__arr iconfont iarrow-down"></span>
    <transition name="fade">
      <ul v-show="sortView.visible" class="filter__list">
        <li
          v-for="opt in sortView.options"
          :key="opt.name"
          class="filter__item"
          @click.prevent="opt.click()"
        >
          <span class="filter__icon iconfont" :class="opt.icon" />
          {{ opt.name }}
          <span
            v-if="newStyle20321B && opt.isActive()"
            class="filter__menu-check iconfont icheck-bold"
            aria-hidden="true"
          />
        </li>
      </ul>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { DocsView } from '@/models/doc'
import { DocsSortView } from '@/models/docs.sort'
import { assertNotNull } from '@/helpers/typing'

const props = withDefaults(
  defineProps<{
    view: DocsView
    newStyle20321B?: boolean
    useQueryString?: boolean
  }>(),
  { newStyle20321B: false, useQueryString: true },
)

const sortView = ref(
  new DocsSortView(
    props.view,
    true,
    props.useQueryString,
    props.newStyle20321B,
  ),
)

function hide(): void {
  assertNotNull(sortView.value).hide()
}
</script>

<style lang="scss" scoped>
.filter__item {
  display: flex;
}
.filter__menu-check {
  flex: 1 1;
  text-align: right;
}
.filter__order--20321B {
  z-index: 4;
  border-radius: 20px;
  width: 80px;
  .filter__list {
    width: 250px;
  }
  .filter__item {
    position: relative;
    &:not(:last-child) {
      padding-bottom: 8px;
    }

    &:not(:last-child):after {
      content: '';
      position: absolute;
      right: 8px;
      bottom: 0;
      left: 8px;
      height: 1px;
      background: $c-black-17;

      .night-mode & {
        background: $c-dark-5;
      }
    }
  }
}
</style>
